import React from 'react';

/**
 * Prevents mouse events from bubbling up to the container.
 * Use this in onClick handlers of buttons inside clickable containers
 * to prevent triggering the container's onClick event.
 *
 */
export const preventScrolling = (e: React.MouseEvent) => {
	e.preventDefault();
	e.stopPropagation();
};
